import ComposerBody from 'flarum/forum/components/ComposerBody';
import Button from 'flarum/common/components/Button';
import TextEditor from 'flarum/common/components/TextEditor';
import ComposerPreview from './ComposerPreview';
import app from 'flarum/forum/app';

export default class Composer extends ComposerBody {
  oninit(vnode) {
    super.oninit(vnode);

    this.previewContent = false;
  }

  // Render
  view() {
    const hasContent = this.composer.fields.content() && this.composer.fields.content() !== '';
    const loading = this.loading || this.attrs.disabled;

    return (
      <div className={`Flarum-Blog-Composer ${loading ? 'Flarum-Blog-Composer-Loading' : ''}`}>
        <div className={'Flarum-Blog-Composer-tabs'}>
          <Button className={!this.previewContent && 'AricleComposerButtonSelected'} onclick={() => (this.previewContent = false)}>
            {app.translator.trans('deepintegrations-custom-blog-ecourse.forum.composer.write')}
          </Button>
          <Button className={this.previewContent && 'AricleComposerButtonSelected'} onclick={() => (this.previewContent = true)}>
            {app.translator.trans('deepintegrations-custom-blog-ecourse.forum.composer.view')}
          </Button>
        </div>

        <div className={`Composer Flarum-Blog-Composer-body ${this.previewContent ? 'Flarum-Blog-Composer-HideEditor' : ''}`}>
          {this.previewContent && (
            <div className={'Flarum-Blog-Composer-preview'}>
              {!hasContent && app.translator.trans('deepintegrations-custom-blog-ecourse.forum.composer.nothing_to_preview')}

              <ComposerPreview content={this.composer.fields.content()} />
            </div>
          )}

          {TextEditor.component({
            submitLabel: this.attrs.submitLabel || app.translator.trans('core.forum.composer_edit.submit_button'),
            placeholder: this.attrs.placeholder,
            disabled: loading,
            composer: this.composer,
            preview: this.jumpToPreview && this.jumpToPreview.bind(this),
            onchange: this.composer.fields.content,
            onsubmit: this.onsubmit.bind(this),
            value: this.composer.fields.content(),
          })}
        </div>
      </div>
    );
  }

  // Submit trigger
  onsubmit() {
    if (this.attrs.onsubmit) {
      this.attrs.onsubmit();
    }
  }
}
